import _regeneratorRuntime from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/asyncToGenerator";
import _classCallCheck from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/classCallCheck";
import _createClass from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/createClass";
import axios from "axios";
import qs from "qs";
import LocalStorage from 'quasar/src/plugins/LocalStorage.js';import SessionStorage from 'quasar/src/plugins/SessionStorage.js';;

var Budget =
/*#__PURE__*/
function () {
  function Budget() {
    _classCallCheck(this, Budget);
  }

  _createClass(Budget, null, [{
    key: "GetBudgetCategories",
    value: function GetBudgetCategories(projectId, doNotShowLoading) {
      return axios.get("/api/Budget/GetBudgetCategories/".concat(projectId), {
        doNotShowLoading: doNotShowLoading
      });
    }
  }, {
    key: "CreateBudget",
    value: function CreateBudget(budgetTimeFrame) {
      return axios.post("/api/Budget/CreateBudget", budgetTimeFrame);
    }
  }, {
    key: "CreateProjectBudget",
    value: function CreateProjectBudget(budgetTimeFrame) {
      return axios.post("/api/Budget/CreateProjectBudget", budgetTimeFrame);
    }
  }, {
    key: "UpdateProjectBudget",
    value: function UpdateProjectBudget(budgetTimeFrame) {
      return axios.patch("/api/Budget/UpdateProjectBudget", budgetTimeFrame);
    }
  }, {
    key: "CreateBudgetCategoryAmount",
    value: function CreateBudgetCategoryAmount(categoryAmount) {
      return axios.post("/api/Budget/CreateBudgetCategoryAmount", categoryAmount);
    }
  }, {
    key: "UpdateBudgetCategoryAmount",
    value: function UpdateBudgetCategoryAmount(categoryAmount) {
      return axios.patch("/api/Budget/UpdateBudgetCategoryAmount", categoryAmount);
    }
  }, {
    key: "GetBudgetsByProjectId",
    value: function GetBudgetsByProjectId(projectId) {
      return axios.get("/api/Budget/GetBudgetsByProjectId/".concat(projectId));
    }
  }, {
    key: "GetBudgetByBudgetId",
    value: function GetBudgetByBudgetId(budgetId) {
      return axios.get("/api/Budget/GetBudgetByBudgetId/".concat(budgetId));
    }
  }, {
    key: "GetStatementQuery",
    value: function GetStatementQuery(propertyId, statmentType, budgetYear, checkAfsSubmitted) {
      return axios.get("/api/Budget/GetStatementQuery/".concat(propertyId, "/").concat(statmentType, "/").concat(budgetYear, "/").concat(checkAfsSubmitted));
    }
  }, {
    key: "GetAllBudgets",
    value: function GetAllBudgets(budgetYear, statusId) {
      return axios.get("/api/Budget/GetAllBudgets", {
        params: {
          budgetYear: budgetYear,
          statusId: statusId
        }
      });
    }
  }, {
    key: "DeleteStatementCategoryBreakdown",
    value: function DeleteStatementCategoryBreakdown(statementCategoryBreakdownId, statementCategoryAmountId) {
      return axios.delete("/api/Budget/DeleteStatementCategoryBreakdown", {
        params: {
          statementCategoryBreakdownId: statementCategoryBreakdownId,
          statementCategoryAmountId: statementCategoryAmountId
        }
      });
    }
  }, {
    key: "GetBudgetCountByKeyLetter",
    value: function GetBudgetCountByKeyLetter(key, selectFilter, subFilter) {
      return axios.get("/api/Budget/GetBudgetCountByKeyLetter", {
        params: {
          key: key,
          statusId: selectFilter,
          budgetYear: subFilter
        }
      });
    }
  }, {
    key: "GetBudget",
    value: function GetBudget(projectId, budgetYear) {
      return axios.get("/api/Budget/GetBudget/".concat(projectId, "/").concat(budgetYear));
    }
  }, {
    key: "IsPreviousAFSRequirementMet",
    value: function IsPreviousAFSRequirementMet(projectId, budgetYear) {
      return axios.get("/api/Budget/IsPreviousAFSRequirementMet/".concat(projectId, "/").concat(budgetYear));
    }
  }, {
    key: "GetAllBudgetCount",
    value: function GetAllBudgetCount() {
      return axios.get("/api/Budget/GetAllBudgetCount");
    }
  }, {
    key: "GetYearRange",
    value: function GetYearRange() {
      return axios.get("/api/Budget/GetYearRange");
    }
  }, {
    key: "GetProjectBudgetById",
    value: function GetProjectBudgetById(budgetId) {
      return axios.get("/api/Budget/GetProjectBudgetById/".concat(budgetId));
    }
  }, {
    key: "GetProjectDetails",
    value: function GetProjectDetails(projectId) {
      return axios.get("/api/Budget/GetProjectDetails/".concat(projectId));
    }
  }, {
    key: "CreateCertification",
    value: function CreateCertification(userId) {
      return axios.post("/api/Budget/CreateCertification", {
        UserId: userId,
        Date: new Date()
      });
    }
  }, {
    key: "GetLastSavedBudget",
    value: function GetLastSavedBudget() {
      return axios.get("/api/Budget/GetLastSavedBudget");
    }
  }, {
    key: "CreateStatementCategoryBreakdown",
    value: function CreateStatementCategoryBreakdown(statementCategoryBreakdown) {
      return axios.post("/api/Budget/CreateStatementCategoryBreakdown", statementCategoryBreakdown);
    }
  }, {
    key: "CreateStatementCategoryAmountBreakdown",
    value: function CreateStatementCategoryAmountBreakdown(statementBreakdownAmount) {
      return axios.post("/api/Budget/CreateStatementCategoryAmountBreakdown", statementBreakdownAmount);
    }
  }, {
    key: "UpdateStatmentDates",
    value: function UpdateStatmentDates(statement) {
      return axios.patch("/api/Budget/UpdateStatementDates", statement);
    }
  }, {
    key: "UnSubmit",
    value: function () {
      var _UnSubmit = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(budgetId) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt("return", axios.post("/api/Budget/UnSubmit/".concat(budgetId)));

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function UnSubmit(_x) {
        return _UnSubmit.apply(this, arguments);
      }

      return UnSubmit;
    }()
  }, {
    key: "CloseInNonCompliance",
    value: function () {
      var _CloseInNonCompliance = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(budgetId) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", axios.post("/api/Budget/CloseInNonCompliance/".concat(budgetId)));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function CloseInNonCompliance(_x2) {
        return _CloseInNonCompliance.apply(this, arguments);
      }

      return CloseInNonCompliance;
    }()
  }, {
    key: "BudgetHasNonCompliance",
    value: function () {
      var _BudgetHasNonCompliance = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(budgetId) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", axios.get("/api/Budget/BudgetHasNonCompliance/".concat(budgetId)));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function BudgetHasNonCompliance(_x3) {
        return _BudgetHasNonCompliance.apply(this, arguments);
      }

      return BudgetHasNonCompliance;
    }()
  }, {
    key: "RemoveFromNonCompliance",
    value: function () {
      var _RemoveFromNonCompliance = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4(budgetId) {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", axios.post("/api/Budget/RemoveFromNonCompliance/".concat(budgetId)));

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function RemoveFromNonCompliance(_x4) {
        return _RemoveFromNonCompliance.apply(this, arguments);
      }

      return RemoveFromNonCompliance;
    }()
  }]);

  return Budget;
}();

export { Budget as default };